export const EXCMDEVICEMODEL_DELETE_RESET = 'EXCMDEVICEMODEL_DELETE_RESET'
export const EXCMDEVICEMODEL_DELETE_SET_ERROR = 'EXCMDEVICEMODEL_DELETE_SET_ERROR'
export const EXCMDEVICEMODEL_DELETE_SET_DELETED = 'EXCMDEVICEMODEL_DELETE_SET_DELETED'
export const EXCMDEVICEMODEL_DELETE_TOGGLE_LOADING = 'EXCMDEVICEMODEL_DELETE_TOGGLE_LOADING'
